/**
 * Created by Gaplo917 on 6/9/2017.
 */
import * as PIXI from 'pixi.js'
import * as Rx from 'rxjs'
import TWEEN from "@tweenjs/tween.js"
import Image from "../../objects/Image";
import R from "../../config/R";
import * as Events from "../../Events";
import {AnimationUtils} from "../../AnimationUtils";
import * as _ from "lodash";
import CustomAnimatedSprite from "../../objects/CustomAnimatedSprite";

export class Spider extends PIXI.Container {
  constructor(x, y, resources){
    super()
    this.x = x
    this.y = y

    const spider = new CustomAnimatedSprite(0,240, resources, R.spines.spider)
    const key = new Image(0,0, resources[R.images.key.name].texture)

    const refBone = spider.spine.skeleton.findBone("bone")

    this.resources = resources
    this.spider = spider
    this.key = key

    this.key.displayGroup = new PIXI.DisplayGroup(3, true)

    this.addChild(key)
    this.addChild(this.spider)
    this.normal()

    Rx.Observable.interval(1000/60)
      .observeOn(Rx.Scheduler.animationFrame)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .takeWhile(() => !this.hasNet)
      .subscribe(() => {
        key.x = refBone.worldX + 20
        key.y = refBone.worldY + 500
      })
  }
  openDoor(){
    return Rx.Observable.create((obs) => {
      this.key.rotation = -2.5
      this._tween = new TWEEN.Tween(this.key)
        .to({x: 1830}, 2000)
        .easing(TWEEN.Easing.Quadratic.InOut)
        .onComplete(() => {
        })
        .start()

      this._tween = new TWEEN.Tween(this.key)
        .to({y: 450}, 2000)
        .easing(TWEEN.Easing.Quadratic.InOut)
        .onComplete(() => {
          obs.next()
          obs.complete()
        })
        .start()
    })
  }

  putTheKeyInNet(key){
    return Rx.Observable.create((obs) => {

      this.spider.playAnimation(R.spines.spider.animations.animation, false, () => {
        this.hasNet = true

        this.setChildIndex(this.spider,0)
        new TWEEN.Tween(this.key)
          .to({x: 1760, y: 450}, 1000)
          .easing(TWEEN.Easing.Exponential.In)
          .onComplete(() => {
            obs.next()
            obs.complete()
          })
          .start()

      })
    })
  }

  removeAllChild(){
    TWEEN.remove(this.winkingTween)
    //this.addChild(this.cobweb)
  }

  normal(){
    this.spider.playAnimation(R.spines.spider.animations.idle, true)
  }
  addOnClickListener(fn) {
    this.interactive = true
    this.buttonMode = true

    this
      .on('mousedown', () => {
      })
      .on('touchstart', () => {
      })
      .on('mouseout', () => {
      })
      .on('mouseover', () => {
      })
      .on('mouseup', (e) => {
        fn(e)
        this.removeOnClickListener()
      })
      .on('touchend', (e) => {
        fn(e)
        this.removeOnClickListener()
      })
  }

  removeOnClickListener(){
    this.interactive = false
    this.buttonMode = false

    this
      .removeListener('mousedown')
      .removeListener('touchstart')
      .removeListener('mouseup')
      .removeListener('touchend')
  }
}



// WEBPACK FOOTER //
// ./src/game/characters/level3/Spider.js